<template>
  <div class="HomeAutoEvalD">
    <modal name="InfoModal" width="300px" height="auto" :scrollable="true" :adaptive="true" :clickToClose="true"
      style="overflow:scroll">
      <div class="modalContent" v-if="modalType == 'error'">
        <i class="fa fa-times modalErrorIcon"></i>
        <h2>Error</h2>
        <p>{{ modalmesagge }}</p>
        <button class="modalButton" @click="closeModal()">Cerrar</button>
      </div>
      <div class="modalContent" v-if="modalType == 'process'">
        <i class="fa fa-exclamation-triangle modalProcessIcon"></i>
        <h2>Cuidado</h2>
        <p>{{ modalmesagge }}</p>
        <button class="modalButton" @click="valAutoevaluation()">Enviar</button>
        <button class="modalButtonCerrar" @click="closeModal()">Cerrar</button>
      </div>
    </modal>

    <div class="titlePage">Autoevaluación</div>
    <!-- <p class="descPage">Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque ratione id accusantium earum itaque magnam, quisquam soluta aspernatur assumenda sequi, hic numquam? Neque commodi, officia hic voluptatem reiciendis modi consequatur!</p> -->
    <div class="instruction">
      <h3>Instrucciones</h3>

      <p>
        <span>1)</span> Seleccione el tipo de actividad ejecutada durante el periodo académico (docencia, investigación,
        proyección social, otras actividades). <br>
        <span>2)</span> Seleccione la subactividad y describa los cursos o actividades ejecutadas durante el periodo
        académico. <br>
        <span>3)</span> Escriba el número de horas semanales que destinó para la actividad.
      </p>

      <button @click="saveData" id="guardar">Ir a Autoevaluación</button>
      <button @click="addActivity" class="btn amarillo">Agregar Actividad</button>
      <router-link :to="'/admin/AutoEvaluacion/'" class="returnButton">Regresar</router-link>
    </div>
    <div class="hoursContent">
      <div class="hoursHeader">
        <div>Actividad</div>
        <div>Sub Actividad</div>
        <div>Descripción</div>
        <div>Horas</div>
        <div>Acciones</div>
      </div>
      <div class="hourActivityContent">
        <div class="hourActivity" v-for="(invoice_hour, index) in invoice_hours" :key="index">
          <select name="nactivity" id="activity" class="activityEsp" v-model="invoice_hour.Activity"
            @change="getSubActivities($event, invoice_hour.id)" required>
            <option v-for="(activity, a) in activities" :value="activity" :key="a">{{ activity }}</option>
          </select>
          <select name="nsubactivity" id="subActivity" class="activityEsp" v-model="invoice_hour.SubActivity" required>
            <option v-for="(subactivity, b) in subactivities[invoice_hour.id].subactivity" :value="subactivity.id"
              :key="b">{{ subactivity.name }}</option>
          </select>
          <input type="text" id="descActivity" class="activityEsp" placeholder="Descripción"
            v-model="invoice_hour.Description" autocomplete="off">
          <input type="number" id="hoursActivity" class="activityEsp" placeholder="Horas" v-model="invoice_hour.Hours"
            step="1" min="1" max="48" autocomplete="off" @change="getTotalHours()">
          <div id="actions" class="activityEsp">
            <i class="fa fa-trash-o action" aria-hidden="true" title="eliminar" @click="deleteHour(invoice_hour)"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="hourTotal">
      <h3>Resumen</h3>
      <p>Total de horas contratadas: <span>{{ totalHoras }}</span></p>
      <p>Total de horas registradas: <span id="ho">{{ nTotalHours }}</span></p>
    </div>
  </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
export default {
  data() {
    return {
      invoice_hours: [{
        id: 0,
        Activity: '',
        SubActivity: '',
        Description: '',
        Hours: 0,
      }],
      alldata: [],
      activities: [],
      subactivities: [{
        id: 0,
        subactivity: [],
      }],
      nTotalHours: 0,
      totalHoras: 0,
      total: 0,
      flag: [0],
      modalmesagge: '',
      finalData: [],
      modalType: '',
      messageNo: 'El total de horas registradas deben ser iguales a las horas contratadas',
      messageEmpty: 'Tiene campos vacios en sus horas registradas, por favor rellene los campos faltantes',
      messageBadHours: 'El total de horas registradas no puede superar el total de horas contratadas',
      messageSuccess: 'Esta segur@ que desea guardar las horas registradas y seguir a la autoevaluación? Si acepta no podrá volver a este formulario',
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide('InfoModal')
    },
    addActivity() {
      const dataerr = this.emptyValidate()
      if (dataerr) {
        if (dataerr == 'vacio') {
          this.modalmesagge = this.messageEmpty
          this.modalType = 'error'
          this.$modal.show('InfoModal')
        } else if (dataerr == 'errHoras') {
          this.modalmesagge = this.messageBadHours
          this.modalType = 'error'
          this.$modal.show('InfoModal')
        } else {
          this.modalmesagge = this.messageSuccess
          this.modalType = 'process'
          this.$modal.show('InfoModal')
        }
      } else {
        this.flag.push(this.flag.length)
        this.invoice_hours.push({
          id: this.flag.length - 1,
          Activity: '',
          SubActivity: '',
          Description: '',
          Hours: 0,
        })
        this.subactivities.push({
          id: this.flag.length - 1,
          subactivity: [],
        })
        this.getTotalHours()
      }
    },

    test() {
      let auto = document.getElementById('guardar')
      let horas = document.getElementById('ho')

      let tipo = typeof (this.nTotalHours)

      if (tipo != 'number') {
        auto.setAttribute('class', 'red')
        horas.style.color = 'red'
      } else if (tipo = 'number' && this.nTotalHours != this.totalHoras) {
        auto.setAttribute('class', 'red')
        auto.setAttribute('v-b-modal.modal-1', '')
        horas.style.color = 'red'
      }
      else if (tipo = 'number' && this.nTotalHours == this.totalHoras) {
        auto.setAttribute('class', 'green')
        horas.style.color = '#222'
      }
    },

    GetHorasContrato() {
      /* let hours = IberoHelpers.getTeacherHour(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner) */
      let hours = IberoHelpers.getTeacherHour(this.$store, 100024858)

      hours.then(datos => {
        this.totalHoras = datos.data[0].total_Actividades
      })
    },


    // Paso 2
    emptyValidate() {
      let dataerr = ''
      for (let i = 0; i < this.invoice_hours.length; i++) {
        if (dataerr != 'errHoras') {
          if ((this.invoice_hours[i].Activity == '') || (this.invoice_hours[i].Activity == null) || (this.invoice_hours[i].Activity == undefined)) {
            dataerr = 'vacio'
          } else if ((this.invoice_hours[i].SubActivity == '') || (this.invoice_hours[i].SubActivity == null) || (this.invoice_hours[i].SubActivity == undefined)) {
            dataerr = 'vacio'
          } else if ((this.invoice_hours[i].Description == '') || (this.invoice_hours[i].Description == null) || (this.invoice_hours[i].Description == undefined)) {
            dataerr = 'vacio'
          } else if ((this.invoice_hours[i].Hours == '') || (this.invoice_hours[i].Hours == null) || (this.invoice_hours[i].Hours == undefined) || (this.invoice_hours[i].Hours <= 0)) {
            dataerr = 'vacio'
          }
        }
      }
      return dataerr
    },
    getTotalHours() {
      let total = 0
      this.total - total

      let isLimitHours = false
      for (let i = 0; i < this.invoice_hours.length; i++) {
        total += parseFloat(this.invoice_hours[i].Hours)
        //if (this.invoice_hours[i].Hours > this.totalHoras) { isLimitHours = true }
        if (total > this.totalHoras) { isLimitHours = true }
      }
      if (isLimitHours) {
        this.nTotalHours = this.messageBadHours
      } else {
        this.nTotalHours = Math.round(total * 10) / 10
      }
    },
    deleteHour(invoice_hour) {
      let idx = this.invoice_hours.indexOf(invoice_hour)
      if (idx > -1) {
        this.invoice_hours.splice(idx, 1)
      }
      this.getTotalHours()
    },
    valAutoevaluation() {
      this.finalData = []
      for (let i = 0; i < this.invoice_hours.length; i++) {
        let obj = {
          id_activity: this.invoice_hours[i].SubActivity,
          description: this.invoice_hours[i].Description,
          hours: Math.round(this.invoice_hours[i].Hours * 10) / 10,
        }
        this.finalData.push(obj)
      }
      return new Promise((resolve, reject) => {
        console.log(this.$session.get('IberoJWTAdminLogin').idBanner)
        //var addAnswer = IberoHelpers.insertHoursAnswer(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, this.finalData, this.$session.get('evalDo').period)
        var addAnswer = IberoHelpers.insertHoursAnswer(this.$store, 100024858, this.finalData, this.$session.get('evalDo').period)
        addAnswer.then(Response => {
          if (Response) {
            resolve(true)
            this.$router.push('/admin/FormAutoEvaluation/')
          } else {
            resolve(false)
            this.closeModal()
            this.modalType = 'error'
            this.modalmesagge = 'No se pudo guardar las horas registradas'
            this.$modal.show('InfoModal')
          }
        })
      })
    },

    // Paso 1
    saveData() {
      const dataerr = this.emptyValidate()

      let tipo = typeof (this.nTotalHours)

      if (this.nTotalHours > this.totalHoras) {
        this.modalmesagge = this.messageBadHours
        this.modalType = 'error'
        this.$modal.show('InfoModal')
      } else if (tipo == 'number' && this.nTotalHours != this.totalHoras || tipo != 'number') {
        this.modalmesagge = this.messageNo
        this.modalType = 'error'
        this.$modal.show('InfoModal')
      } else if (dataerr == 'vacio') {
        this.modalmesagge = this.messageEmpty
        this.modalType = 'error'
        this.$modal.show('InfoModal')
      } else if (dataerr == 'errHoras') {
        this.modalmesagge = this.messageBadHours
        this.modalType = 'error'
        this.$modal.show('InfoModal')
      } else {
        this.modalmesagge = this.messageSuccess
        this.modalType = 'process'
        this.$modal.show('InfoModal')
      }
    },
    getActivities() {
      if (this.alldata.length != undefined) {
        const activitiess = IberoHelpers.getTeacherActivities(this.$store)
        this.alldata = activitiess
      }
      this.alldata.then(activitiesData => {
        for (let i = 0; i < activitiesData.data.length; i++) {
          if (this.activities.indexOf(activitiesData.data[i].Act_Type) == -1) {
            this.activities.push(activitiesData.data[i].Act_Type)
          }
        }
      })
    },
    getSubActivities(event, id) {
      this.subactivities[id].subactivity = []
      const activity = event.target.value
      this.alldata.then(activitiesData => {
        for (let i = 0; i < activitiesData.data.length; i++) {
          if (activitiesData.data[i].Act_Type == activity) {
            let objsub = {
              id: activitiesData.data[i].Id_Activity,
              name: activitiesData.data[i].Activity,
            }
            this.subactivities[id].subactivity.push(objsub)
          }
        }
      })
    },
  },
  created() {
    this.getActivities()
  },
  updated() {
    this.test()
  },
  mounted() {
    this.GetHorasContrato()
  },
}
</script>
<style scoped>
.amarillo {
  border: #d0ab4b 2px solid !important;
  color: #d0ab4b !important;
}

.amarillo:hover {
  border: #d0ab4b 2px solid !important;
  background-color: #d0ab4b !important;
  color: #fff !important;
}

.HomeAutoEvalD {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

.red {
  color: white !important;
  background-color: #a2273c !important;
}

.red:hover{
  border-color: #a2273c !important;
}

.green {
  color: #fff !important;
  background-color: #28a745 !important;
}

.green:hover{
  border-color: #28a745 !important;
}

.titlePage {
  color: #d0ab4b;
  border-color: #d0ab4b;
  width: 100%;
}

.descPage {
  width: 100%;
  text-align: left;
  margin: 20px 0;
}

.instruction {
  width: 350px;
  box-sizing: border-box;
  padding-right: 30px;
}

.instruction>h3 {
  font-size: 20px;
  color: #d0ab4b;
  font-weight: bold;
}

.instruction>button {
  width: 200px;
  padding: 7px 20px;
  box-sizing: border-box;
  border-radius: 10px;
  color: #222;
  background-color: #fff;
  border-color: #222;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  border: 3px solid transparent;
  transition: all .5s linear;
  font-weight: bold;
  font-size: 15px;
}

.instruction>button:hover {
  color: #fff;
  border: 3px solid #222;
  background-color: #222;
}

.instruction>p {
  font-size: 15px;
}

.instruction>p>span {
  color: #d0ab4b;
  font-weight: bold;
}

.hoursContent {
  width: calc(100% - 350px);
  height: 500px;
  overflow-y: auto;
}

.hoursHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px 7px 0 0;
  background-color: #d0ab4b;
}

.hoursHeader>div {
  padding: 15px;
  color: #FFF;
  width: 25%;
  font-weight: bold;
  text-align: center;
  border-right: 1px dotted #FFF;
}

.hoursHeader>div:nth-last-child(1) {
  border: none;
}

.hourActivityContent {
  display: flex;
  flex-direction: column-reverse;
}

.hourActivity {
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px dotted rgb(204, 204, 204);
  display: flex;
  justify-content: center;
  align-items: center;
}

.hourActivity:nth-child(even) {
  background-color: #a2273c0b;
}

.activityEsp {
  width: 27%;
  margin: 10px 1%;
  box-sizing: border-box;
  border: none;
  border-bottom: 2px dotted gray;
  background-color: transparent;
  resize: none;
  height: 50px;
  transition: all 300ms linear;
}

.activityEsp:focus {
  border-bottom: 2px solid #d0ab4b;
}

#actions {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
}

.action {
  padding: 6px;
  box-sizing: border-box;
  border-radius: 3px;
  background-color: #fff;
  color: #222;
  border-color: #222;
  font-size: 1.2em;
  transition: all 300ms linear;
  border: 3px solid transparent;
  cursor: pointer;
}

.action:hover {
  border: 3px solid #222;
  color: #fff;
  background-color: transparent;
}

.returnButton {
  color: #222;
  border: 3px solid #222;
  background-color: fff;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 10px;
  margin-top: 20px;
  width: 200px;
  text-align: center;
  padding: 7px 20px;
  display: inline-block;
  font-weight: bold;
  font-size: 15px;
}

.hourTotal {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 20px 20px 20px 350px;
}

.hourTotal h3 {
  color: #d0ab4b;
  font-weight: bold;
  font-size: 21px;
  text-transform: uppercase;
  width: 100%;
  padding-top: 15px;
  border-top: 1px dotted gray;
}

.hourTotal p {
  width: 100%;
  margin: 7px 0;
  font-size: 14px;
  font-weight: bold;
  color: #d0ab4b;
}

.hourTotal p span {
  color: #222;
  font-weight: normal;
}

.modalContent {
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.modalContent h2 {
  margin: 20px 0;
  color: #a2273c;
  font-weight: bold;
  font-size: 25px;
  text-transform: uppercase;
}

.modalContent p {
  margin: 0;
  text-align: center;
  font-size: 15px;
}

.modalErrorIcon,
.modalProcessIcon {
  border-radius: 50%;
  height: 80px;
  width: 80px;
  border: 8px solid #a2273c;
  font-size: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a2273c;
}

.modalProcessIcon {
  border: 8px solid #cc9329;
  color: #cc9329;
}

.modalButton {
  width: 200px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 10px;
  color: #fff;
  background-color: #d0ab4b;
  border-color: #d0ab4b;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  border: 3px solid transparent;
  transition: all .5s linear;
  font-weight: bold;
  font-size: 17px;
}

.modalButton:hover {
  color: #fff;
  border: 3px solid #d0ab4b;
  background-color: #d0ab4b;
}

.modalButtonCerrar {
  width: 200px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 10px;
  color: #222;
  background-color: #fff;
  border-color: #222 !important;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  border: 3px solid transparent;
  transition: all .5s linear;
  font-weight: bold;
  font-size: 17px;
}


.modalButtonCerrar:hover {
  color: #fff;
  background-color: #222 !important;
}
</style>
